import { useMemo } from "react";
import { useCustomFormContext } from "@/components/site-builder/modules/CustomFormModule/context/customFormContext";
import { useCustomFormStateOfResidenceOptions } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormStateOfResidenceOptions";
import { FormBuilderFieldCode } from "@/constants/form-builder";

export function useCustomFormFilteredRows() {
  const {
    formEntity: {
      data: { rows = [] },
    },
  } = useCustomFormContext();
  const stateOptions = useCustomFormStateOfResidenceOptions();
  const hasStateField = stateOptions.length > 0;

  return useMemo(
    () =>
      rows
        .map((row) => ({
          ...row,
          columns: row.columns?.filter(
            (column) =>
              hasStateField ||
              column.code !== FormBuilderFieldCode.StateOfResidence,
          ),
        }))
        .filter((row) => row.columns?.length > 0),
    [rows, hasStateField],
  );
}
